import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes as Switch, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { getAllRoutes, wrapRoute } from './routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import ErrorBoundary, { handleError } from './components/ErrorBoundary';
import ToastNotifications from './components/ToastNotifications';
import LoadingScreen from './components/LoadingScreen';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      onError: (error) => {
        toast.error(error.message || 'An error occurred');
      },
    },
  },
});

function App() {
  // Set up global error handler
  React.useEffect(() => {
    window.addEventListener('error', (event) => {
      handleError(event.error);
    });

    window.addEventListener('unhandledrejection', (event) => {
      handleError(event.reason);
    });

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleError);
    };
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div className='app'>
        <ErrorBoundary>
          <Router>
            <ScrollToTop />
            <Suspense fallback={<LoadingScreen />}>
              <Switch>
                {getAllRoutes().map((route) => {
                  const wrappedRoute = wrapRoute(route);
                  return (
                    <Route 
                      key={wrappedRoute.path}
                      path={wrappedRoute.path} 
                      exact={wrappedRoute.exact} 
                      Component={wrappedRoute.component} 
                    />
                  );
                })}
              </Switch>
            </Suspense>
          </Router>
        </ErrorBoundary>
        <ToastNotifications />
      </div>
    </QueryClientProvider>
  );
}

export default App;
